import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";

export default function TemplateConfirmation(response:any) {
  return (
    <div className="h-[90vh] max-w-xl border rounded-xl border-gray-300 overflow-y-auto pn_scroller">
        <div className=" p-3 border-b border-gray-300">
          <h1 className="text-lg font-bold text-gray-900 mb-1">
            MR Insights Market Report Template
          </h1>
          <p className="text-gray-600 text-sm">
            Comprehensive analysis of market dynamics, competitive landscape, and strategic opportunities
          </p>
        </div>
        
        <div className="bg-white rounded-lg shadow-lg px-3 space-y-2 mt-4 pb-4">
          {Object.entries(response?.response?.sections).map(([sectionKey, section]:any) => (
            <AccordionItem 
              key={sectionKey} 
              title={`${sectionKey}. ${section.title}`}
            >
              <SectionContent section={section} sectionKey={sectionKey} />
            </AccordionItem>
          ))}
        </div>
    </div>
  );
}

function SectionContent({ section, sectionKey }:any) {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 p-4 rounded-lg">
        <p className="text-sm font-semibold text-blue-900 mb-1">Summary:</p>
        <p className="text-sm text-blue-800">{section?.summary}</p>
      </div>
      
      <div className="text-gray-700">
        <p className="whitespace-pre-line">{section.body}</p>
      </div>
      
      {section?.subsections && (
        <div className="mt-4 space-y-2 ml-2 border-l-2 border-gray-200 pl-4">
          {Object.entries(section?.subsections).map(([subKey, sub]:any) => (
            <AccordionItem 
              key={subKey} 
              title={`${subKey} ${sub.title}`}
              isSubsection
            >
              <div className="space-y-3">
                <div className="bg-green-50 p-3 rounded">
                  <p className="text-xs font-semibold text-green-900 mb-1">Summary:</p>
                  <p className="text-xs text-green-800">{sub.summary}</p>
                </div>
                <p className="text-sm text-gray-700 whitespace-pre-line">{sub.body}</p>
              </div>
            </AccordionItem>
          ))}
        </div>
      )}
    </div>
  );
}

function AccordionItem({ title, children, isSubsection = false }:any) {
  const [open, setOpen] = useState(false);
  
  return (
    <div className={`border bg-gray-100 border-gray-300 p-2 rounded-xl ${isSubsection ? 'py-2' : 'py-4'}`}>
      <button
        className={`w-full text-left flex justify-between items-center group transition-colors hover:text-blue-600 ${
          isSubsection ? 'text-sm font-medium' : 'text-base font-semibold'
        }`}
        onClick={() => setOpen(!open)}
      >
        <span className="flex-1">{title}</span>
        <span className={`ml-4 flex-shrink-0 text-xl transition-transform ${
          open ? 'rotate-0' : 'rotate-0'
        } ${isSubsection ? 'text-base' : 'text-xl'}`}>
          {open ?  <ChevronDown className="w-2 h-2 text-slate-500" /> : <ChevronRight className="w-2 h-2 text-slate-500" /> }    
        </span>
      </button>
      
      {open && (
        <div className={`text-gray-700 transition-all ${
          isSubsection ? 'mt-2' : 'mt-4'
        }`}>
          {children}
        </div>
      )}
    </div>
  );
}